import React, { useCallback, useEffect, useRef, useState } from 'react';

import {

  resolveCrmGuest, getCrmGuestDetail, addCrmNote, setCrmTags,

  createCrmTask,

  updateCrmGuestProfile, updateCrmGuestContact,

  setCrmGuestExcluded, deleteCrmGuest,

} from '../../services/api';

import { formatMoney, formatNumber, relativeTime, formatDate } from '../../utils/formatters';

import {

  Insight, KpiGrid, PeriodStrip, ActivityChart, Habits, RecentVisits, LegacyTrend,

} from './guest/GuestOverview';

import './CrmGuestDrawer.css';



/* Иконки рисуем штрихом вместо эмодзи: наследуют цвет текста и не «пляшут»

   между операционными системами (см. Navbar.jsx). */

const Icon = ({ children }) => (

  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">

    {children}

  </svg>

);

const IconClose = () => <Icon><path d="M19.0068 5L5.00684 19" /><path d="M19 19L5 5" /></Icon>;

const IconTrash = () => <Icon><path d="M20.5 6H3.5" /><path d="M18.8333 8.5L18.3734 15.3991C18.1964 18.054 18.1079 19.3815 17.2429 20.1907C16.3779 21 15.0475 21 12.3867 21H11.6133C8.95252 21 7.62212 21 6.75711 20.1907C5.8921 19.3815 5.8036 18.054 5.62661 15.3991L5.16667 8.5" /><path d="M9.5 11L10 16" /><path d="M14.5 11L14 16" /><path d="M6.5 6C6.55588 6 6.58382 6 6.60915 5.99936C7.43259 5.97849 8.15902 5.45491 8.43922 4.68032C8.44784 4.65649 8.45667 4.62999 8.47434 4.57697L8.57143 4.28571C8.65431 4.03708 8.69575 3.91276 8.75071 3.8072C8.97001 3.38607 9.37574 3.09364 9.84461 3.01877C9.96213 3 10.0932 3 10.3553 3H13.6447C13.9068 3 14.0379 3 14.1554 3.01877C14.6243 3.09364 15.03 3.38607 15.2493 3.8072C15.3043 3.91276 15.3457 4.03708 15.4286 4.28571L15.5257 4.57697C15.5433 4.62992 15.5522 4.65651 15.5608 4.68032C15.841 5.45491 16.5674 5.97849 17.3909 5.99936C17.4162 6 17.4441 6 17.5 6" /></Icon>;

const IconWarning = () => <Icon><path d="M5.31171 10.7615C8.23007 5.58716 9.68925 3 12 3C14.3107 3 15.7699 5.58716 18.6883 10.7615L19.0519 11.4063C21.4771 15.7061 22.6897 17.856 21.5937 19.428C20.4978 21 17.7864 21 12.3637 21H11.6363C6.21356 21 3.50217 21 2.40626 19.428C1.31034 17.856 2.52291 15.7061 4.94805 11.4063L5.31171 10.7615Z" /><path d="M12 8V13" /><path d="M12 16H12.0001" /></Icon>;

const IconPen = () => <Icon><path d="M4 22H20" /><path d="M13.8881 3.66293L14.6296 2.92142C15.8581 1.69286 17.85 1.69286 19.0786 2.92142C20.3071 4.14999 20.3071 6.14188 19.0786 7.37044L18.3371 8.11195M13.8881 3.66293C13.8881 3.66293 13.9807 5.23862 15.3711 6.62894C16.7614 8.01926 18.3371 8.11195 18.3371 8.11195M13.8881 3.66293L7.07106 10.4799C6.60933 10.9416 6.37846 11.1725 6.17992 11.4271C5.94571 11.7273 5.74491 12.0522 5.58107 12.396C5.44219 12.6874 5.33894 12.9972 5.13245 13.6167L4.25745 16.2417M4.25745 16.2417L4.04356 16.8833C3.94194 17.1882 4.02128 17.5243 4.2485 17.7515C4.47573 17.9787 4.81182 18.0581 5.11667 17.9564L5.75834 17.7426L8.38334 16.8675C9.00282 16.6611 9.31256 16.5578 9.60398 16.4189C9.94775 16.2551 10.2727 16.0543 10.5729 15.8201C10.8275 15.6215 11.0584 15.3907 11.5201 14.9289L18.3371 8.11195M5.75834 17.7426L4.25745 16.2417" /></Icon>;

const IconPhone = () => <Icon><path d="M13.5 2C13.5 2 15.8335 2.21213 18.8033 5.18198C21.7731 8.15183 21.9853 10.4853 21.9853 10.4853" /><path d="M14.207 5.53564C14.207 5.53564 15.197 5.81849 16.6819 7.30341C18.1668 8.78834 18.4497 9.77829 18.4497 9.77829" /><path d="M17.6763 20.9631C18.1917 20.9122 18.6399 20.6343 19.0011 20.254L20.4217 18.7584C21.3806 17.7489 21.1102 16.0182 19.8833 15.312L17.9728 14.2123C17.1672 13.7486 16.1858 13.8848 15.5562 14.5477L15.1007 15.0272C15.1007 15.0272 14.0181 16.167 11.0631 13.0559C8.10812 9.94484 9.1907 8.80507 9.1907 8.80507L9.47752 8.50311C10.1841 7.75924 10.2507 6.56497 9.63424 5.6931L8.37326 3.90961C7.61028 2.8305 6.13596 2.68795 5.26145 3.60864L3.69185 5.26114C3.25823 5.71766 2.96765 6.30945 3.00289 6.96594C3.09304 8.64546 3.81072 12.259 7.81536 16.4752C12.0621 20.9462 16.0468 21.1239 17.6763 20.9631Z" /></Icon>;

const IconNote = () => <Icon><path d="M2 4.99792V16.1437C2 17.2547 2.90605 18.1536 4.01486 18.2229C4.98428 18.2836 6.12329 18.4021 7 18.6335C8.08145 18.9189 9.37293 19.5366 10.3724 20.0694C11.3852 20.6092 12.6148 20.6092 13.6276 20.0694C14.6271 19.5366 15.9185 18.9189 17 18.6335C17.8767 18.4021 19.0157 18.2836 19.9851 18.2229C21.094 18.1536 22 17.2547 22 16.1437V4.93332C22 3.86087 21.1538 2.98053 20.082 3.01787C18.9534 3.05718 17.5469 3.17415 16.5 3.48757C15.5924 3.75929 14.5353 4.30431 13.6738 4.80287C12.6355 5.40379 11.3428 5.43636 10.2823 4.87558C9.29611 4.35413 8.04921 3.76443 7 3.48757C6.11349 3.25363 4.95877 3.13502 3.9824 3.07501C2.8863 3.00764 2 3.89975 2 4.99792Z" /><path d="M12 5.50049V20.5005" /></Icon>;

const IconTaskDone = () => <Icon><circle cx="12" cy="12" r="10" /><path d="M8.5 12.5L10.5 14.5L15.5 9.5" /></Icon>;

const IconTaskOpen = () => <Icon><path d="M2 12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4H14C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12V14C22 17.7712 22 19.6569 20.8284 20.8284C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V12Z" /><path d="M7 4V2.5" /><path d="M17 4V2.5" /><circle cx="16.5" cy="16.5" r="1.5" /><path d="M2.5 9H21.5" /></Icon>;

const IconVisit = () => <Icon><path d="M2.00098 11.999L16.001 11.999M12.501 14.999L16.001 11.999L12.501 8.99902" /><path d="M9.00195 7C9.01406 4.82497 9.11051 3.64706 9.87889 2.87868C10.7576 2 12.1718 2 15.0002 2L16.0002 2C18.8286 2 20.2429 2 21.1215 2.87868C22.0002 3.75736 22.0002 5.17157 22.0002 8L22.0002 16C22.0002 18.8284 22.0002 20.2426 21.1215 21.1213C20.2429 22 18.8286 22 16.0002 22H15.0002C12.1718 22 10.7576 22 9.87889 21.1213C9.11051 20.3529 9.01406 19.175 9.00195 17" /></Icon>;

const IconTag = () => <Icon><path d="M4.72848 16.1369C3.18295 14.5914 2.41018 13.8186 2.12264 12.816C1.83509 11.8134 2.08083 10.7485 2.57231 8.61875L2.85574 7.39057C3.26922 5.59881 3.47597 4.70292 4.08944 4.08944C4.70292 3.47597 5.59881 3.26922 7.39057 2.85574L8.61875 2.57231C10.7485 2.08083 11.8134 1.83509 12.816 2.12264C13.8186 2.41018 14.5914 3.18295 16.1369 4.72848L17.9665 6.55812C20.6555 9.24711 22 10.5916 22 12.2623C22 13.933 20.6555 15.2775 17.9665 17.9665C15.2775 20.6555 13.933 22 12.2623 22C10.5916 22 9.24711 20.6555 6.55812 17.9665L4.72848 16.1369Z" /><circle cx="8.607" cy="8.879" r="2" transform="rotate(-45 8.607 8.879)" /><path d="M11.5417 18.5L18.5208 11.5208" /></Icon>;

const IconGraphUp = () => <Icon><path d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" /><path d="M7 14L9.29289 11.7071C9.68342 11.3166 10.3166 11.3166 10.7071 11.7071L12.2929 13.2929C12.6834 13.6834 13.3166 13.6834 13.7071 13.2929L17 10M14.5 10H17V12.5" /></Icon>;

const IconGift = () => <Icon><path d="M22 12H2" /><path d="M12 2V22" /><path d="M13 12C13 14.2091 14.7909 16 17 16" /><path d="M11 12C11 14.2091 9.20914 16 7 16" /><path d="M12 10.0352C12 8.54529 13.014 7.24659 14.4594 6.88524C16.0631 6.48431 17.5158 7.93697 17.1148 9.5407C16.7535 10.9861 15.4548 12.0001 13.9649 12.0001H12V10.0352Z" /><path d="M12.0001 10.0352C12.0001 8.54529 10.9861 7.24659 9.5407 6.88524C7.93698 6.48431 6.48431 7.93697 6.88524 9.5407C7.24659 10.9861 8.54529 12.0001 10.0352 12.0001H12.0001V10.0352Z" /><path d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" /></Icon>;

const IconShield = () => <Icon><path d="M3 10.4167C3 7.21907 3 5.62028 3.37752 5.08241C3.75503 4.54454 5.25832 4.02996 8.26491 3.00079L8.83772 2.80472C10.405 2.26824 11.1886 2 12 2C12.8114 2 13.595 2.26824 15.1623 2.80472L15.7351 3.00079C18.7417 4.02996 20.245 4.54454 20.6225 5.08241C21 5.62028 21 7.21907 21 10.4167V11.9914C21 17.6294 16.761 20.3655 14.1014 21.5273C13.38 21.8424 13.0193 22 12 22C10.9807 22 10.62 21.8424 9.89856 21.5273C7.23896 20.3655 3 17.6294 3 11.9914V10.4167Z" /><path d="M9.5 12.4L10.9286 14L14.5 10" /></Icon>;

const IconStar = () => <Icon><path d="M9.15316 5.40838C10.4198 3.13613 11.0531 2 12 2C12.9469 2 13.5802 3.13612 14.8468 5.40837L15.1745 5.99623C15.5345 6.64193 15.7144 6.96479 15.9951 7.17781C16.2757 7.39083 16.6251 7.4699 17.3241 7.62805L17.9605 7.77203C20.4201 8.32856 21.65 8.60682 21.9426 9.54773C22.2352 10.4886 21.3968 11.4691 19.7199 13.4299L19.2861 13.9372C18.8096 14.4944 18.5713 14.773 18.4641 15.1177C18.357 15.4624 18.393 15.8341 18.465 16.5776L18.5306 17.2544C18.7841 19.8706 18.9109 21.1787 18.1449 21.7602C17.3788 22.3417 16.2273 21.8115 13.9243 20.7512L13.3285 20.4768C12.6741 20.1755 12.3469 20.0248 12 20.0248C11.6531 20.0248 11.3259 20.1755 10.6715 20.4768L10.0757 20.7512C7.77268 21.8115 6.62118 22.3417 5.85515 21.7602C5.08912 21.1787 5.21588 19.8706 5.4694 17.2544L5.53498 16.5776C5.60703 15.8341 5.64305 15.4624 5.53586 15.1177C5.42868 14.773 5.19043 14.4944 4.71392 13.9372L4.2801 13.4299C2.60325 11.4691 1.76482 10.4886 2.05742 9.54773C2.35002 8.60682 3.57986 8.32856 6.03954 7.77203L6.67589 7.62805C7.37485 7.4699 7.72433 7.39083 8.00494 7.17781C8.28555 6.96479 8.46553 6.64194 8.82547 5.99623L9.15316 5.40838Z" /></Icon>;



const STATUS_TITLES = { active: 'Активен', risk: 'Под риском', lost: 'Потерян' };

const SOURCE_LABELS = {

  cloud: 'Статистика гостя из программы лояльности (iiko)',

  card: 'Статистика по карте — карта может быть общей',

};

const TABS = [

  { key: 'overview', label: 'Обзор' },

  { key: 'feed', label: 'Лента' },

  { key: 'profile', label: 'Профиль' },

];



// Cloud и iiko.biz называют поля статистики по-разному (total_spend/spend) —

// сводим к одному набору имён, чтобы карточка не разбиралась в источниках.

const normalizeStats = (stats) => {

  if (!stats) return null;

  return {

    visits: stats.visits ?? null,

    orders: stats.orders ?? null,

    spend: stats.total_spend ?? stats.spend ?? null,

    spendYear: stats.spend_year ?? null,

    spendMonth: stats.spend_month ?? null,

    spendWeek: stats.spend_week ?? null,

    avgCheck: stats.avg_check ?? null,

    firstVisit: stats.first_visit ?? null,

    lastVisit: stats.last_visit ?? null,

    trend: stats.trend || null,

  };

};



const initialsOf = (name, fallback) => {

  const parts = (name || '').trim().split(/\s+/).filter(Boolean);

  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();

  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();

  return (fallback || '?').slice(-2);

};



const CrmGuestDrawer = ({ guest, availableUsers, allTags, onClose, onChanged }) => {

  const [detail, setDetail] = useState(null);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState('');

  const [tab, setTab] = useState('overview');

  const [composer, setComposer] = useState('note');

  const [focusComposer, setFocusComposer] = useState(0);

  const [tagInput, setTagInput] = useState('');

  const [noteText, setNoteText] = useState('');

  const [taskTitle, setTaskTitle] = useState('');

  const [taskDue, setTaskDue] = useState('');

  const [taskAssignee, setTaskAssignee] = useState('');

  const [busy, setBusy] = useState(false);

  const [birthdayInput, setBirthdayInput] = useState('');

  const [preferencesInput, setPreferencesInput] = useState('');

  const [profileBusy, setProfileBusy] = useState(false);

  const [editingContact, setEditingContact] = useState(false);

  const [contactName, setContactName] = useState('');

  const [contactPhone, setContactPhone] = useState('');

  const [contactEmail, setContactEmail] = useState('');

  const [contactBusy, setContactBusy] = useState(false);

  const [contactError, setContactError] = useState('');

  const [accountBusy, setAccountBusy] = useState(false);

  const [accountError, setAccountError] = useState('');

  const noteRef = useRef(null);

  const taskRef = useRef(null);

  const drawerRef = useRef(null);

  const tabsRef = useRef(null);

  const [scrolled, setScrolled] = useState(false);



  const load = useCallback(async (crmId) => {

    setLoading(true);

    setError('');

    try {

      const res = await getCrmGuestDetail(crmId);

      setDetail(res);

    } catch (err) {

      setError(err.response?.data?.error || 'Не удалось загрузить карточку');

    } finally {

      setLoading(false);

    }

  }, []);



  useEffect(() => {

    let crmId = guest.crm?.id;

    (async () => {

      if (!crmId) {

        setLoading(true);

        const res = await resolveCrmGuest({ card_number: guest.card });

        crmId = res.guest?.id;

        onChanged?.();

      }

      if (crmId) load(crmId);

    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [guest.card]);



  // Сбрасываем черновики полей только при смене гостя, а не при каждом

  // refresh() — иначе правка "О госте"/контакта затиралась бы фоновым

  // обновлением ленты, вызванным чем-то не связанным (например, задачей).

  useEffect(() => {

    setBirthdayInput(detail?.guest?.birthday || '');

    setPreferencesInput(detail?.guest?.preferences || '');

    setContactName(detail?.guest?.name || '');

    setContactPhone(detail?.guest?.phone || '');

    setContactEmail(detail?.guest?.email || '');

    setEditingContact(false);

    setContactError('');

    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [detail?.guest?.id]);



  // Esc закрывает, фон под карточкой не прокручивается.

  useEffect(() => {

    const onKey = (e) => { if (e.key === 'Escape') onClose(); };

    document.addEventListener('keydown', onKey);

    const prevOverflow = document.body.style.overflow;

    document.body.style.overflow = 'hidden';

    return () => {

      document.removeEventListener('keydown', onKey);

      document.body.style.overflow = prevOverflow;

    };

  }, [onClose]);



  // Кнопки «Заметка»/«Задача» в шапке — переключают на ленту и ставят курсор

  // в нужное поле (после того как вкладка отрисовалась).

  useEffect(() => {

    if (!focusComposer) return;

    const el = composer === 'note' ? noteRef.current : taskRef.current;

    el?.focus();

  }, [focusComposer, composer]);



  // Прокрутка общая (на телефоне шапка не должна съедать экран), поэтому

  // при смене вкладки возвращаемся к её началу — но только если ушли ниже.

  const switchTab = (key) => {

    setTab(key);

    const drawer = drawerRef.current;

    const tabs = tabsRef.current;

    if (drawer && tabs) {

      const top = tabs.offsetTop - (drawer.querySelector('.gp-topbar')?.offsetHeight || 0);

      if (drawer.scrollTop > top) drawer.scrollTop = top;

    }

  };



  const onScroll = (e) => setScrolled(e.currentTarget.scrollTop > 72);



  const openComposer = (kind) => {

    setComposer(kind);

    switchTab('feed');

    setFocusComposer((n) => n + 1);

  };



  const refresh = () => detail && load(detail.guest.id);



  const saveProfile = async () => {

    if (!detail) return;

    if ((birthdayInput || '') === (detail.guest.birthday || '')

      && (preferencesInput || '') === (detail.guest.preferences || '')) return;

    setProfileBusy(true);

    try {

      await updateCrmGuestProfile(detail.guest.id, {

        birthday: birthdayInput, preferences: preferencesInput,

      });

      await refresh();

    } finally {

      setProfileBusy(false);

    }

  };



  const submitContact = async (e) => {

    e.preventDefault();

    if (!detail) return;

    setContactBusy(true);

    setContactError('');

    try {

      await updateCrmGuestContact(detail.guest.id, {

        name: contactName.trim(), phone: contactPhone.trim(), email: contactEmail.trim(),

      });

      setEditingContact(false);

      await refresh();

      onChanged?.();

    } catch (err) {

      setContactError(err.response?.data?.error || 'Не удалось сохранить контакт');

    } finally {

      setContactBusy(false);

    }

  };



  const cancelContactEdit = () => {

    setContactName(detail?.guest?.name || '');

    setContactPhone(detail?.guest?.phone || '');

    setContactEmail(detail?.guest?.email || '');

    setContactError('');

    setEditingContact(false);

  };



  const addTag = async (e) => {

    e.preventDefault();

    const tag = tagInput.trim();

    if (!tag || !detail) return;

    const tags = Array.from(new Set([...(detail.tags || []), tag]));

    setTagInput('');

    await setCrmTags(detail.guest.id, tags);

    await refresh();

    onChanged?.();

  };



  const removeTag = async (tag) => {

    if (!detail) return;

    const tags = (detail.tags || []).filter((t) => t !== tag);

    await setCrmTags(detail.guest.id, tags);

    await refresh();

    onChanged?.();

  };



  const toggleExcluded = async (e) => {

    if (!detail) return;

    const excluded = !e.target.checked;

    setAccountBusy(true);

    setAccountError('');

    try {

      await setCrmGuestExcluded(detail.guest.id, excluded);

      await refresh();

      onChanged?.();

    } catch (err) {

      setAccountError(err.response?.data?.error || 'Не удалось сохранить');

    } finally {

      setAccountBusy(false);

    }

  };



  const removeGuest = async () => {

    if (!detail) return;

    const who = detail.guest.name || detail.guest.phone || guest.card || 'гостя';

    if (!window.confirm(`Удалить ${who} из CRM? Заметки, задачи, теги и история визитов удалятся без возможности восстановления. Синхронизация с iiko не вернёт гостя — только ручное «Сохранить в CRM».`)) return;

    setAccountBusy(true);

    setAccountError('');

    try {

      await deleteCrmGuest(detail.guest.id);

      onChanged?.();

      onClose();

    } catch (err) {

      setAccountError(err.response?.data?.error || 'Не удалось удалить гостя');

      setAccountBusy(false);

    }

  };



  const addNote = async (e) => {

    e.preventDefault();

    if (!noteText.trim() || !detail) return;

    setBusy(true);

    try {

      await addCrmNote(detail.guest.id, noteText.trim());

      setNoteText('');

      await refresh();

    } finally {

      setBusy(false);

    }

  };



  const addTask = async (e) => {

    e.preventDefault();

    if (!taskTitle.trim() || !detail) return;

    setBusy(true);

    try {

      await createCrmTask({

        guest_id: detail.guest.id,

        title: taskTitle.trim(),

        due_date: taskDue || null,

        assignee_id: taskAssignee || null,

      });

      setTaskTitle('');

      setTaskDue('');

      setTaskAssignee('');

      await refresh();

      onChanged?.();

    } finally {

      setBusy(false);

    }

  };



  const n = normalizeStats(detail?.stats);

  const profile = detail?.profile || null;

  const rank = detail?.rank || null;

  const loyalty = detail?.loyalty || null;

  const program = detail?.guest?.cloud_stats || null;



  // У гостя из программы (iiko.biz/Cloud) статистика в ЗАКАЗАХ (один визит в

  // баню — несколько заказов), визиты по дням — из журнала. У карты OLAP —

  // визиты. До загрузки карточки берём числа из строки списка.

  const byOrders = detail ? detail.stats_source === 'cloud' : guest.unit === 'order';

  const lastVisit = profile?.last ?? n?.lastVisit ?? guest.last_visit ?? null;

  const spendYear = n?.spendYear ?? guest.spend_year ?? null;

  const tier = (loyalty?.categories || [])[0];



  const tiles = [];

  const money = (v) => formatMoney(Math.round(v || 0));

  if (byOrders) {

    // Траты за год есть только у гостей из iiko.biz; без них первая плитка —

    // траты за всё время, чтобы не показывать «0 ₽» там, где просто нет поля.

    tiles.push(spendYear != null ? {

      key: 'year', label: 'За 365 дней', value: money(spendYear),

      sub: rank ? `топ ${rank.top_pct}% · ${formatNumber(rank.position)} из ${formatNumber(rank.total)}` : null,

      accent: rank?.valuable,

    } : { key: 'total', label: 'Всего', value: money(n?.spend ?? guest.spend), sub: 'за всё время' });

    tiles.push(profile

      ? { key: 'visits', label: 'Визитов', value: formatNumber(profile.visits), sub: `с ${formatDate(profile.first)}` }

      : { key: 'orders', label: 'Заказов', value: formatNumber(n?.orders ?? guest.visits ?? 0), sub: 'за всё время' });

    tiles.push(profile

      ? { key: 'avg', label: 'Средний визит', value: money(profile.avg_visit), sub: `средний заказ ${money(n?.avgCheck)}` }

      : { key: 'avg', label: 'Средний заказ', value: money(n?.avgCheck ?? guest.avg_check) });

    if (loyalty && loyalty.balance != null) {

      tiles.push({ key: 'bonus', label: 'Бонусы', value: Number(loyalty.balance).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), sub: tier || null });

    } else if (spendYear != null) {

      tiles.push({ key: 'total', label: 'Всего', value: money(n?.spend ?? guest.spend), sub: 'за всё время' });

    }

  } else {

    tiles.push({ key: 'visits', label: 'Визитов', value: formatNumber(n?.visits ?? guest.visits ?? 0) });

    tiles.push({ key: 'spend', label: 'Выручка', value: money(n?.spend ?? guest.spend) });

    tiles.push({ key: 'avg', label: 'Средний чек', value: money(n?.avgCheck ?? guest.avg_check) });

    tiles.push({ key: 'first', label: 'Первый визит', value: n?.firstVisit ? formatDate(n.firstVisit) : '—' });

  }



  const periods = byOrders && n && (n.spendWeek != null || n.spendMonth != null) ? [

    { label: 'Неделя', value: n.spendWeek || 0 },

    { label: 'Месяц', value: n.spendMonth || 0 },

    { label: 'Всё время', value: n.spend || 0 },

  ] : null;



  const name = detail?.guest?.name || guest.name || guest.crm?.name || '';

  const phone = detail?.guest?.phone || guest.crm?.phone || '';

  const status = guest.status || 'unknown';

  const tags = detail?.tags || guest.crm?.tags || [];

  const excluded = detail ? !!detail.guest.excluded : !!guest.crm?.excluded;



  // Единая лента: заметки, задачи, первый/последний визит и события (теги,

  // статус, акции) — всё, что у нас реально есть с датой, по времени.

  const feed = [];

  if (detail) {

    (detail.notes || []).forEach((note) => {

      feed.push({ key: `note-${note.id}`, type: 'note', date: note.created_at, icon: <IconNote />, data: note });

    });

    (detail.tasks || []).forEach((t) => {

      feed.push({

        key: `task-${t.id}`,

        type: t.status === 'done' ? 'task_done' : 'task_open',

        date: t.completed_at || t.created_at,

        icon: t.status === 'done' ? <IconTaskDone /> : <IconTaskOpen />,

        data: t,

      });

    });

    if (n?.firstVisit) {

      feed.push({ key: 'visit-first', type: 'visit_first', date: n.firstVisit, icon: <IconVisit />, data: n });

    }

    if (lastVisit && lastVisit !== n?.firstVisit) {

      feed.push({ key: 'visit-last', type: 'visit_last', date: lastVisit, icon: <IconVisit />, data: n });

    }

    (detail.events || []).forEach((ev) => {

      const icons = {

        tag_added: <IconTag />, tag_removed: <IconTag />, status_changed: <IconGraphUp />,

        promotion_credit: <IconGift />, task_auto_closed: <IconTaskDone />, bot_registered: <IconTaskDone />, welcome_bonus: <IconGift />,

      };

      feed.push({ key: `event-${ev.id}`, type: ev.type, date: ev.created_at, icon: icons[ev.type] || null, data: ev });

    });

    feed.sort((a, b) => new Date(b.date) - new Date(a.date));

  }

  const openTasks = (detail?.tasks || []).filter((t) => t.status !== 'done').length;



  let journalNote = null;

  if (detail && byOrders && !profile) {

    journalNote = detail.journal_status === 'not_found'

      ? 'Гость не найден в iiko Cloud — помесячной истории визитов нет.'

      : 'История визитов гостя ещё загружается — ритм, привычки и график появятся после загрузки.';

  }



  const overview = (

    <>

      <Insight profile={profile} lastVisit={lastVisit} status={status} />

      <KpiGrid tiles={tiles} />

      {periods && <PeriodStrip items={periods} />}

      {profile && <ActivityChart profile={profile} />}

      {!profile && <LegacyTrend trend={n?.trend} />}

      {journalNote && <div className="gp-note">{journalNote}</div>}

      <Habits profile={profile} loyaltySince={loyalty?.loyalty_since} firstVisit={n?.firstVisit} />

      {profile && <RecentVisits recent={profile.recent} />}

    </>

  );



  const feedTab = (

    <>

      <section className="gp-card">

        <div className="gp-segmented" role="tablist" aria-label="Что добавить">

          <button type="button" role="tab" aria-selected={composer === 'note'}

            className={composer === 'note' ? 'is-active' : ''} onClick={() => setComposer('note')}>

            <IconNote /> Заметка

          </button>

          <button type="button" role="tab" aria-selected={composer === 'task'}

            className={composer === 'task' ? 'is-active' : ''} onClick={() => setComposer('task')}>

            <IconTaskOpen /> Задача

          </button>

        </div>

        {composer === 'note' ? (

          <form className="gp-composer" onSubmit={addNote}>

            <textarea

              ref={noteRef}

              placeholder="Что важно знать о госте: разговор, пожелание, жалоба…" value={noteText}

              onChange={(e) => setNoteText(e.target.value)}

              rows={3}

            />

            <div className="gp-composer-actions">

              <button className="btn-primary" type="submit" disabled={busy || !noteText.trim()}>Добавить заметку</button>

            </div>

          </form>

        ) : (

          <form className="gp-composer" onSubmit={addTask}>

            <input

              ref={taskRef}

              type="text" placeholder="Например: позвонить и пригласить на выходные" value={taskTitle}

              onChange={(e) => setTaskTitle(e.target.value)}

            />

            <div className="gp-composer-row">

              <label>

                <span>Срок</span>

                <input type="date" value={taskDue} onChange={(e) => setTaskDue(e.target.value)} />

              </label>

              <label>

                <span>Исполнитель</span>

                <select value={taskAssignee} onChange={(e) => setTaskAssignee(e.target.value)}>

                  <option value="">Не назначен</option>

                  {availableUsers.map((u) => (

                    <option key={u.id} value={u.id}>{u.name}</option>

                  ))}

                </select>

              </label>

            </div>

            <div className="gp-composer-actions">

              <button className="btn-primary" type="submit" disabled={busy || !taskTitle.trim()}>Создать задачу</button>

            </div>

          </form>

        )}

      </section>



      <div className="gp-timeline">

        {feed.length === 0 && <div className="crm-empty">Пока пусто — добавьте первую заметку</div>}

        {feed.map((item) => (

          <div key={item.key} className={`gp-tl-item tl-${item.type}`}>

            <span className="gp-tl-icon">{item.icon}</span>

            <div className="gp-tl-body">

              {item.type === 'note' && (

                <>

                  <div className="gp-tl-meta">

                    <strong>{item.data.author_name}</strong>

                    <span>{relativeTime(item.date)}</span>

                  </div>

                  <div className="gp-tl-text">{item.data.text}</div>

                </>

              )}

              {(item.type === 'task_open' || item.type === 'task_done') && (

                <>

                  <div className={`gp-tl-title ${item.data.status === 'done' ? 'done' : ''}`}>

                    {item.data.title}

                  </div>

                  <div className="gp-tl-meta">

                    <span>{item.type === 'task_done' ? 'выполнена' : 'создана'} · {relativeTime(item.date)}</span>

                    {item.data.due_date && <span>до {formatDate(item.data.due_date)}</span>}

                    {item.data.assignee_name && <span>{item.data.assignee_name}</span>}

                  </div>

                </>

              )}

              {(item.type === 'visit_first' || item.type === 'visit_last') && (

                <div className="gp-tl-meta">

                  <strong>{item.type === 'visit_first' ? 'Первый визит' : 'Последний визит'}</strong>

                  <span>{formatDate(item.date)}</span>

                </div>

              )}

              {(item.type === 'tag_added' || item.type === 'tag_removed') && (

                <div className="gp-tl-meta">

                  <strong>{item.type === 'tag_added' ? 'Добавлен тег' : 'Убран тег'} «{item.data.payload.tag}»</strong>

                  <span>{item.data.actor_name || 'система'} · {relativeTime(item.date)}</span>

                </div>

              )}

              {item.type === 'status_changed' && (

                <div className="gp-tl-meta">

                  <strong>

                    Статус: {STATUS_TITLES[item.data.payload.from] || item.data.payload.from}

                    {' → '}

                    {STATUS_TITLES[item.data.payload.to] || item.data.payload.to}

                  </strong>

                  <span>{relativeTime(item.date)}</span>

                </div>

              )}

              {item.type === 'promotion_credit' && (

                <div className="gp-tl-meta">

                  <strong>Начислено {formatNumber(item.data.payload.amount)} бонусов по акции «{item.data.payload.promotion_name}»</strong>

                  <span>{relativeTime(item.date)}</span>

                </div>

              )}

              {(item.type === 'excluded' || item.type === 'included') && (

                <div className="gp-tl-meta">

                  <strong>{item.type === 'excluded' ? 'Гость снят с учёта в аналитике' : 'Гость снова учитывается в аналитике'}</strong>

                  <span>{item.data.actor_name || 'система'} · {relativeTime(item.date)}</span>

                </div>

              )}

              {item.type === 'bot_registered' && (

                <div className="gp-tl-meta">

                  <strong>

                    Зарегистрирован в программе лояльности через бота {item.data.payload?.channel === 'max' ? 'MAX' : 'Telegram'}

                    {item.data.payload?.program_error ? ' — в программу не зачислен, проверьте в iiko' : ''}

                  </strong>

                  <span>{relativeTime(item.date)}</span>

                </div>

              )}

              {item.type === 'welcome_bonus' && (

                <div className="gp-tl-meta">

                  <strong>

                    Начислен приветственный бонус {formatNumber(item.data.payload?.amount)} за подписку

                    в {item.data.payload?.channel === 'max' ? 'MAX' : 'Telegram'}

                  </strong>

                  <span>{relativeTime(item.date)}</span>

                </div>

              )}

              {item.type === 'task_auto_closed' && (

                <div className="gp-tl-meta">

                  <strong>Задача «{item.data.payload.title}» закрыта автоматически — гость вернулся</strong>

                  <span>{relativeTime(item.date)}</span>

                </div>

              )}

            </div>

          </div>

        ))}

      </div>

    </>

  );



  const profileTab = detail && (

    <>

      <section className="gp-card">

        <div className="gp-card-head">

          <h4>Контакт</h4>

          {!editingContact && (

            <button className="gp-link" onClick={() => setEditingContact(true)}><IconPen /> Изменить</button>

          )}

        </div>

        {editingContact ? (

          <form className="gp-form" onSubmit={submitContact}>

            <label><span>Имя</span>

              <input type="text" value={contactName} onChange={(e) => setContactName(e.target.value)} />

            </label>

            <label><span>Телефон</span>

              <input type="tel" placeholder="+7 999 123-45-67" value={contactPhone} onChange={(e) => setContactPhone(e.target.value)} />

            </label>

            <label><span>Email</span>

              <input type="email" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)} />

            </label>

            <div className="gp-composer-actions">

              <button type="button" className="ui-btn-ghost" onClick={cancelContactEdit} disabled={contactBusy}>Отмена</button>

              <button className="btn-primary" type="submit" disabled={contactBusy}>Сохранить</button>

            </div>

            {contactError && <div className="crm-drawer-error"><IconWarning /> {contactError}</div>}

          </form>

        ) : (

          <dl className="gp-dl">

            <div><dt>Имя</dt><dd>{detail.guest.name || <span className="gp-dim">не указано</span>}</dd></div>

            <div><dt>Телефон</dt><dd>{detail.guest.phone

              ? <a href={`tel:${detail.guest.phone}`}>{detail.guest.phone}</a>

              : <span className="gp-dim">не указан</span>}</dd></div>

            <div><dt>Email</dt><dd>{detail.guest.email

              ? <a href={`mailto:${detail.guest.email}`}>{detail.guest.email}</a>

              : <span className="gp-dim">не указан</span>}</dd></div>

            {guest.card && <div><dt>Карта</dt><dd className="gp-mono">{guest.card}</dd></div>}

          </dl>

        )}

      </section>



      <section className="gp-card">

        <div className="gp-card-head">

          <h4>О госте</h4>

          {profileBusy && <span className="gp-card-note">Сохранение…</span>}

        </div>

        <div className="gp-form">

          <label>

            <span>День рождения</span>

            <input type="date" value={birthdayInput}

              onChange={(e) => setBirthdayInput(e.target.value)} onBlur={saveProfile} />

          </label>

          <label>

            <span>Предпочтения</span>

            <textarea placeholder="Например: парная пожарче, веник дубовый, чай без сахара…"

              value={preferencesInput} rows={3}

              onChange={(e) => setPreferencesInput(e.target.value)} onBlur={saveProfile} />

          </label>

        </div>

      </section>



      <section className="gp-card">

        <div className="gp-card-head"><h4>Теги</h4></div>

        <div className="gp-tags">

          {tags.length === 0 && <span className="gp-dim">Тегов нет</span>}

          {tags.map((t) => (

            <span className="crm-tag" key={t}>

              {t}

              <button onClick={() => removeTag(t)} aria-label={`Убрать тег ${t}`}><IconClose /></button>

            </span>

          ))}

        </div>

        <form className="gp-inline-form" onSubmit={addTag}>

          <input type="text" placeholder="Новый тег" value={tagInput}

            onChange={(e) => setTagInput(e.target.value)} list="crm-tag-suggestions" />

          <button className="ui-btn-ghost" type="submit" disabled={!tagInput.trim()}>Добавить</button>

        </form>

        <datalist id="crm-tag-suggestions">

          {(allTags || []).map((t) => <option key={t.tag} value={t.tag} />)}

        </datalist>

      </section>



      {(program?.source === 'iikobiz' || loyalty) && (

        <section className="gp-card">

          <div className="gp-card-head"><h4>Программа лояльности</h4></div>

          <dl className="gp-dl">

            {tier && <div><dt>Уровень</dt><dd>{(loyalty.categories || []).join(', ')}</dd></div>}

            {loyalty?.balance != null && <div><dt>Бонусы</dt><dd>{Number(loyalty.balance).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</dd></div>}

            {(program?.registered || loyalty?.loyalty_since) && (

              <div><dt>В программе с</dt><dd>{formatDate(program?.registered || loyalty?.loyalty_since)}</dd></div>

            )}

            {program?.consent != null && (

              <div><dt>Согласие на ПД</dt><dd className={program.consent ? 'gp-ok' : 'gp-dim'}>

                {program.consent ? <><IconShield /> есть</> : 'нет'}

              </dd></div>

            )}

            {program?.promo_ok != null && (

              <div><dt>Рассылки об акциях</dt><dd className={program.promo_ok ? 'gp-ok' : 'gp-dim'}>

                {program.promo_ok ? 'получает' : 'отказался'}

              </dd></div>

            )}

          </dl>

        </section>

      )}



      <section className="gp-card">

        <div className="gp-card-head"><h4>Учёт гостя</h4></div>

        <label className="gp-check">

          <input type="checkbox" checked={!excluded} onChange={toggleExcluded} disabled={accountBusy} />

          <span>

            <strong>Учитывать гостя</strong>

            <span className="gp-dim">

              Снимите галочку для сотрудников, служебных и тестовых карт: гость останется в CRM,

              но пропадёт из аналитики, авто-задач, акций и предложений.

            </span>

          </span>

        </label>

        <div className="gp-danger">

          <div>

            <strong>Удалить из CRM</strong>

            <span className="gp-dim">Вместе с заметками, задачами, тегами и историей визитов.</span>

          </div>

          <button type="button" className="gp-danger-btn" onClick={removeGuest} disabled={accountBusy}>

            <IconTrash /> Удалить гостя

          </button>

        </div>

        {accountError && <div className="crm-drawer-error"><IconWarning /> {accountError}</div>}

      </section>



      <div className="gp-source">

        {detail.guest.created_at && <span>В CRM с {formatDate(detail.guest.created_at)}</span>}

        {SOURCE_LABELS[detail.stats_source] && <span>{SOURCE_LABELS[detail.stats_source]}</span>}

      </div>

    </>

  );



  return (

    <div className="crm-drawer-overlay" onClick={onClose}>

      <div className="crm-drawer gp" role="dialog" aria-modal="true" aria-label={name || 'Карточка гостя'}

        ref={drawerRef} onScroll={onScroll} onClick={(e) => e.stopPropagation()}>

        <div className={`gp-topbar ${scrolled ? 'is-scrolled' : ''}`}>

          <span className="gp-topbar-name">{name || 'Карточка гостя'}</span>

          <button className="gp-close" onClick={onClose} aria-label="Закрыть"><IconClose /></button>

        </div>

        <header className="gp-header">

          <div className="gp-hero">

            <div className={`gp-avatar st-${status}`}>{initialsOf(name, guest.card)}</div>

            <div className="gp-hero-main">

              <h3 className="gp-name">{name || 'Имя неизвестно'}</h3>

              <div className="gp-hero-sub">

                {phone ? <a href={`tel:${phone}`} className="gp-phone">{phone}</a>

                  : guest.card ? <span className="gp-mono">{guest.card}</span> : null}

              </div>

              <div className="gp-badges">

                <span className={`gb-badge st-${status}`}>{STATUS_TITLES[status] || 'Нет визитов'}</span>

                {excluded && <span className="gp-badge gp-badge--muted">Не учитывается</span>}

                {rank?.valuable && <span className="gp-badge gp-badge--gold"><IconStar /> Ценный гость</span>}

                {rank && !rank.valuable && rank.top_pct <= 30 && <span className="gp-badge">Топ {rank.top_pct}%</span>}

                {tier && <span className="gp-badge">{tier}</span>}

                {tags.slice(0, 3).map((t) => <span className="crm-tag" key={t}>{t}</span>)}

                {tags.length > 3 && <span className="gp-badge">+{tags.length - 3}</span>}

              </div>

            </div>

          </div>

          <div className="gp-actions">

            {phone && <a className="gp-action" href={`tel:${phone}`}><IconPhone /> Позвонить</a>}

            <button type="button" className="gp-action" onClick={() => openComposer('note')} disabled={!detail}>

              <IconNote /> Заметка

            </button>

            <button type="button" className="gp-action" onClick={() => openComposer('task')} disabled={!detail}>

              <IconTaskOpen /> Задача

            </button>

          </div>

        </header>

        <nav className="gp-tabs" role="tablist" ref={tabsRef}>

          {TABS.map((t) => (

            <button key={t.key} type="button" role="tab" aria-selected={tab === t.key}

              className={tab === t.key ? 'is-active' : ''} onClick={() => switchTab(t.key)}>

              {t.label}

              {t.key === 'feed' && openTasks > 0 && <span className="gp-tab-count">{openTasks}</span>}

            </button>

          ))}

        </nav>



        <div className="gp-body">

          {error && <div className="crm-drawer-error"><IconWarning /> {error}</div>}

          {loading && !detail && (

            <div className="gp-skeleton" aria-label="Загрузка">

              <span /><span /><span /><span />

            </div>

          )}

          {detail && tab === 'overview' && overview}

          {detail && tab === 'feed' && feedTab}

          {detail && tab === 'profile' && profileTab}

        </div>

      </div>

    </div>

  );

};



export default CrmGuestDrawer;

